import { type FC, useEffect } from 'react';

import { useRouteError } from 'react-router-dom';

import { isChunkLoadError, reloadOnce } from '@shared/lib';

import styles from './RouteError.module.css';

/** Экран ошибки роутера. Устаревшую сборку чиним перезагрузкой, остальное — показываем */
export const RouteError: FC = () => {
  const error = useRouteError();
  const staleBuild = isChunkLoadError(error);

  useEffect(() => {
    if (staleBuild) reloadOnce();
  }, [staleBuild]);

  return (
    <div className={styles.root} role="alert">
      <h1 className={styles.title}>
        {staleBuild ? 'Сайт обновился' : 'Критическая ошибка приложения'}
      </h1>
      <p className={styles.text}>
        {staleBuild
          ? 'Загружаем новую версию страницы…'
          : 'Попробуйте обновить страницу. Если ошибка повторится — позвоните нам.'}
      </p>
      <button className={styles.button} type="button" onClick={() => window.location.reload()}>
        Обновить страницу
      </button>
    </div>
  );
};
